import { render, staticRenderFns } from "./AnchorLinkItemComponent.vue?vue&type=template&id=4f994604&"
import script from "./AnchorLinkItemComponent.vue?vue&type=script&lang=js&"
export * from "./AnchorLinkItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports